import { render, staticRenderFns } from "./SmsCreate.vue?vue&type=template&id=48f6126c&scoped=true"
import script from "./SmsCreate.vue?vue&type=script&lang=js"
export * from "./SmsCreate.vue?vue&type=script&lang=js"
import style0 from "./SmsCreate.vue?vue&type=style&index=0&id=48f6126c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f6126c",
  null
  
)

export default component.exports